export function isShowLoginAlert (state) {
  return state.toggleLoginAlert
}
export function isShowLoginModal (state) {
  return state.toggleLoginModal
}
export function isShowMenuSidebar (state) {
  return state.toggleMenuSidebar
}
export function isShowUserSidebar (state) {
  return state.toggleUserSidebar
}
export function isVacanciesLoading (state) {
  return state.vacanciesLoading
}
export function isCompaniesLoading (state) {
  return state.companiesLoading
}
export function isShowUserResumeEditTextareaDialog (state) {
  return state.toogleUserEditResumeTextareaDialog
}
export function isUserAuthTouchExpired (state) {
  return Math.abs(state.userAuthTouchTimestamp - Date.now()) > 18800
}
export function isCompanyAuthTouchExpired (state) {
  return Math.abs(state.companyAuthTouchTimestamp - Date.now()) > 18800
}



// WEBPACK FOOTER //
// ./src/vuex/utilities/getters.js